export default __webpack_public_path__ + "static/media/thumb-video-modal.460779db.png";